import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../_services/auth.service';
import { GlobalService } from '../../../_services/global.service';
import { MentorshipService } from '../../../_services/mentorship.service';
import { StaffService } from '../../../_services/staff.service';

@Component({
  selector: 'iq-central-front-end-view-mentees',
  templateUrl: './view-mentees.component.html',
  styleUrls: ['./view-mentees.component.scss']
})
export class ViewMenteesComponent implements OnInit {
  mentees: any[] = [];
  mentorId: any;
  staffs: any [] = [];
  sub: Subscription = new Subscription();
  staff;
  courses: any[] = [];
  learningPath: any[] = [];
  constructor(
    private _global: GlobalService, 
    private _mentorship: MentorshipService,
    private _activatedRoute: ActivatedRoute,
    private _staffs: StaffService,
    private _authService: AuthService
  ) {}

  ngOnInit(): void {
    
    this.getOnementor();
    console.log(this.mentorId);
    
  }

  getOnementor() {
    const userDetails = this._authService.getLoggedInUser();
    this.mentorId = userDetails.mentorId;
    this._mentorship.getMentor(this.mentorId).subscribe({
      next: response => {
        console.log('Hey', response);
        this.mentees = response['responseResult'].mentees;
        console.log(this.mentees);
        
      }
    });
  }
}
